import request from '@/utils/request'

export function add(data) {
    return request({
        url: 'api/seriesTasks',
        method: 'post',
        data
    })
}

export function del(id) {
    return request({
        url: 'api/seriesTasks/' + id,
        method: 'delete'
    })
}

export function edit(data) {
    return request({
        url: 'api/seriesTasks',
        method: 'put',
        data
    })
}

export function getTaskAll(id) {
    return request({
        url: 'api/taskAll?id=' + id,
        method: 'get'
    })
}

export function postUpdateByUserTaskOne(data) {
    return request({
        url: 'api/updateByUserTaskOne',
        method: 'post',
        data
    })
}
